module.exports = "/build/web/svg/captain.721713d52a0fad1d5a1cef4ca4cb892c.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/captain.svg
// module id = 107
// module chunks = 24